import { BaseModel } from '../base';
import { MessageModel } from './message';

class ConversationModel extends BaseModel {
  $postMessage(body) {
    return new Promise((resolve, reject) => {
      this
        .$post('self', {}, body)
        .then((message) => {
          message = new MessageModel(message);

          resolve(message);
        });
    });
  }
}

export {
  ConversationModel
};
